module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-scale-d0679e8f10af59c8e15880596c68ed5c.png";